// extracted by mini-css-extract-plugin
export default {"textContainer":"LegalNotice_textContainer__hFpwu","sectionTitle":"LegalNotice_sectionTitle__QTSWW"};